<script>
import _ from 'lodash';
import BaseFilters from '../base-filters.vue';
import Api from '@/store/jsonapi';

export default {
  extends: BaseFilters,

  data: function () {
    let filters = [
      {
        name: this.$i18n.t('all'),
        conditions: [],
        built_in: true
      }
    ];

    return {
      group: 'backend-order-channels',
      order_channels: [],
      customers: [],
      built_in_filters: filters
    };
  },

  computed: {
    attributes() {
      let attrs = [
        {
          name: 'order_channel_type_id',
          type: 'Array',
          value: this.order_channels
        }
      ];

      return attrs;
    }
  },

  methods: {
    after_mount() {
      if (this.can('read_order_channel_types')) {
        Api.findAllPages('order_channel_types', {
          sort: 'name',
          fields: { order_channel_types: 'name,id' }
        }).then(({ data }) => {
          this.order_channels = _(data)
            .map((e) => ({ val: e.id, label: e.name }))
            .value();
        });
      }
    }
  }
};
</script>
